// Core
import React from "react";
import ReactDOM from "react-dom";

// Theme
import "./theme/init";

import Resume from "./pages/Resume";

ReactDOM.render(<Resume />, document.getElementById("app"));
